export interface CustomerImport {
  excelUrl?: string;
  keyColumn?: string;
  columns?: string[];
  keyProp?: CustomerMergeProp;
  props?: { [index: string]: CustomerImport };
  total: number;
}

export interface CustomerMergeProp {
  field: string;
  fieldType: number;
  builtIn: boolean;
  overwrite: boolean;
}

const customerImport: CustomerImport = {
  excelUrl: undefined,
  keyColumn: undefined,
  columns: undefined,
  keyProp: undefined,
  props: undefined,
  total: 0,
};

export default customerImport;
